<ng-container *ngIf="viewType === 'detail' || viewType === 'assignmentDetail'">
	<app-content-view [optionMenu]="optionMenu" (optionInfo)="optionInfo($event)">
		<content-title>
			{{locale.translate('assignment')}}
		</content-title>
		<content-area>
			<ng-container *ngIf="assignmentDetail">
				<div class="assignment-detail-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="22px">

					<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px" fxFlex="1 1 100">
						<div class="detail-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
								<div class="detail-block-body" fxLayout="row wrap" fxLayoutAlign="space-between stretch"
									fxLayoutGap="10px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="10px">
									<div fxLayout="row wrap" fxLayoutAlign="start center" class="data-container">
										<div class="data-item" fxFlex="220px" fxFlex.xs="auto">
											<app-common-view
												[data]="{label: locale.translate('assigned_by'), type: 'chip', chipData: {type: 'prime', data: {title: assignmentDetail?.assigner?.name, imageSrc: assignmentDetail?.assigner?.profilePicURL}}}">
											</app-common-view>
										</div>
										<ng-container *ngIf="assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName">
											<div class="data-item" fxFlex="220px" fxFlex.xs="auto">
												<app-common-view
													[data]="{label: locale.translate('assigned_to'), type: 'chip', chipData: {type: 'prime', data: {title: assignmentDetail?.workgroup?.groupName, svgIcon: 'workgroup'}}}">
												</app-common-view>
											</div>
										</ng-container>
										<ng-container *ngIf="!(assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName)">
											<div class="data-item" fxFlex="220px" fxFlex.xs="auto">
												<app-common-view
													[data]="{label: locale.translate('assigned_to'), type: 'chip', chipData: {type: 'prime', data: {title: assignmentDetail?.assignee?.name, imageSrc: assignmentDetail?.assignee?.profilePicURL}}}">
												</app-common-view>
											</div>
										</ng-container>
									</div>
									<div class="sub-txt-patch asg-status" [ngClass]="assignmentDetail?.status.key">
										{{assignmentDetail?.status?.caption}}</div>
								</div>
							</div>
						</div>

						<div class="detail-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
							<!-- <h4 class="detail-block-title">
								{{locale.translate('assignment')}}
							</h4> -->
							<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
								<div class="detail-block-body" fxLayout="row wrap" fxLayoutAlign="space-between stretch"
									fxLayoutGap="10px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="10px">
									<div fxLayout="row wrap" fxLayoutAlign="start center" class="data-container">
										<div class="data-item" fxFlex="220px" fxFlex.xs="auto">
											<app-common-view
												[data]="{label: locale.translate('assigned_on'), value: assignmentDetail?.assignedDT}">
											</app-common-view>
										</div>
										<ng-container *ngIf="assignmentDetail?.completeByTime">
											<div class="data-item warning" fxFlex="220px" fxFlex.xs="auto">
												<app-common-view [ngClass]="assignmentDetail?.status.key"
													[data]="{label: (assignmentDetail?.type?.key === 'submission') ? locale.translate('submit_by') : locale.translate('complete_by'), value: assignmentDetail?.completeByTime, icon: (assignmentDetail?.status.key === 'overdue') ? 'warning': ''}">
												</app-common-view>
											</div>
										</ng-container>
									</div>
									<ng-container
										*ngIf="(currentUser?.userID === assignmentDetail?.assignee?.userID) && ['assigned', 'overdue'].includes(assignmentDetail?.status?.key) && assignmentDetail?.type?.key === 'submission'">
										<div class="button-blocks" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="32px">
											<button class="submit-btn" mat-stroked-button #submitBtn
												(click)="submit('submit', submitBtn, assignmentDetail)">{{locale.translate('submit')}}</button>
										</div>
									</ng-container>
								</div>
								<ng-container *ngIf="assignmentDetail?.assignerNotes">
									<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<app-common-view
											[data]="{label: locale.translate('notes'), value: assignmentDetail?.assignerNotes}">
										</app-common-view>
									</div>
								</ng-container>
								<!---notes-->
								<!-- <ng-container>
									<div class="notes-details" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
										<p class="sub-caption-2">Notes</p>
										<div class="sub-caption-1">
											<p>The assignees will see this as an activity in their dashboard. You can track progress in the
												Stats tab. If you dont’ want to track, then use “Forward” option.</p>
										</div>
									</div>
								</ng-container> -->
								<!---submission-completion-list-->
								<ng-container *ngIf="assignmentDetail?.workGroupAssignment?.length">
									<div class="sub-com-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
										<p class="block-title">
											{{locale.translate('submission')}} / {{locale.translate('completion')}}
										</p>
										<div fxLayout="row" fxLayoutAlign="start start">
											<!-- <ng-container *ngIf="assignmentDetail?.workGroupAssignment?.length">
												<app-common-list [layout]="'column'" [layoutGap]="'28px'">
													<list-item class="question-item"
														*ngFor="let workGroupAssignment of assignmentDetail?.workGroupAssignment; trackBy: gfService.trackByID.bind({'key': 'assignmentID'})"> -->
									<app-readability class="app-readability" height="200">
												
										<content>
												<div class="assignee-list" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px" fxFlex.xs="1 1">
													<ng-container
														*ngFor="let workGroupAssignment of assignmentDetail?.workGroupAssignment; trackBy: gfService.trackByID.bind({'key': 'assignmentID'})">
														<div class="assignee-item" fxFlex="1 1" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxLayout="row"
															fxLayoutAlign="start center" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
															<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="3px" fxFlex="0 0 306px"
																fxFlex.xs="auto">
																<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="space-between stretch">
																	<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="start stretch">
																		<app-chips type="prime"
																			[data]="{title: workGroupAssignment?.assignee?.name, imageSrc: workGroupAssignment?.assignee?.profilePicURL}"
																			(title)="courseProgressDetail(workGroupAssignment)">
																		</app-chips>
																	</div>
																	<div  fxFlex="1 1" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
																		<ng-container
																			*ngIf="workGroupAssignment?.type?.key === 'completion' && workGroupAssignment?.completedTime">
																			<app-common-view class="common-view-info"
																				[data]="{label: locale.translate('completed'), value: workGroupAssignment?.completedTime}">
																			</app-common-view>
																		</ng-container>
																		<ng-container *ngIf="workGroupAssignment?.type?.key === 'submission'">
																			<ng-container
																				*ngIf="workGroupAssignment?.status?.key === 'submitted' && workGroupAssignment?.completedTime">
																				<app-common-view class="common-view-info"
																					[data]="{label: locale.translate('submitted'), value: workGroupAssignment?.completedTime}">
																				</app-common-view>
																			</ng-container>
																			<ng-container
																				*ngIf="workGroupAssignment?.status?.key === 'closed' && workGroupAssignment?.evalDT">
																				<app-common-view class="common-view-info"
																					[data]="{label: locale.translate('completed'), value: workGroupAssignment?.evalDT}">
																				</app-common-view>
																			</ng-container>
																		</ng-container>

																		<!-- <div class="sub-txt-patch" [ngClass]="{'success' : (['submitted','assigned'].includes(assignmentDetail?.status?.key)
																		),
																		'error' : (['reassigned','closed', 'overdue', 'aborted'].includes(assignmentDetail?.status?.key))}"
																					fxLayoutAlign="center center">
																					overdue
																				</div> -->
																		<div class="sub-txt-patch asg-status" [ngClass]="workGroupAssignment?.status.key">
																			{{workGroupAssignment?.status?.caption}}
																		</div>
																	</div>
																</div>
																<div class="progress-dtls" fxLayout="row" fxLayoutAlign="center center">
																	<mat-progress-bar class="progress-br" color="primary" mode="determinate"
																		[value]="workGroupAssignment?.progress">
																	</mat-progress-bar>
																</div>
															</div>
															<ng-container
																*ngIf="!['assigned', 'overdue'].includes(workGroupAssignment?.status?.key) && workGroupAssignment?.status?.key !== 'closed' && workGroupAssignment?.status?.key === 'submitted'">
																<div class="button-blocks"  fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.xs="center center"
																	fxLayoutGap="5px">
																	<button class="submit-btn" mat-stroked-button #workGroupAssignmentEvaluateBtn
																		(click)="submit('evaluate', workGroupAssignmentEvaluateBtn, workGroupAssignment)">
																		{{locale.translate('evaluate')}}
																	</button>
																	<button mat-button class="reassign-btn" type="button" #workGroupAssignmentReassignBtn
																		(click)="submit('reassign', workGroupAssignmentReassignBtn, workGroupAssignment)">
																		<div fxLayoutAlign="center center" fxLayoutGap="5px">
																			<mat-icon class="reply-icon">replay</mat-icon>
																			<span>{{locale.translate('reassign')}}</span>
																		</div>
																	</button>
																</div>
															</ng-container>
														</div>
													</ng-container>
												</div>
										</content>
									</app-readability>
										</div>
									</div>
								</ng-container>
								  <!-- individual -->
								  <ng-container *ngIf="!assignmentDetail?.workGroupAssignment?.length">
									<div class="sub-com-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
										<p class="block-title">
											{{locale.translate('submission')}} / {{locale.translate('completion')}}
										</p>
										<div fxLayout="row" fxLayoutAlign="start start">
										<div class="assignee-list" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px" fxFlex.xs="1 1">
											<ng-container
												>
												<div class="assignee-item" fxFlex="1 1" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxLayout="row"
													fxLayoutAlign="start center" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
													<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="3px" fxFlex="0 0 306px"
														fxFlex.xs="auto">
														<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="space-between stretch">
															<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="start stretch">
																<app-chips type="prime"
																	[data]="{title: assignmentDetail?.assignee?.name, imageSrc: assignmentDetail?.assignee?.profilePicURL}"
																	(title)="courseProgressDetail(assignmentDetail)">
																</app-chips>
															</div>
															<div  fxFlex="1 1" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
																<ng-container
																	*ngIf="assignmentDetail?.type?.key === 'completion' && assignmentDetail?.completedTime">
																	<app-common-view class="common-view-info"
																		[data]="{label: locale.translate('completed'), value: assignmentDetail?.completedTime}">
																	</app-common-view>
																</ng-container>
																<ng-container *ngIf="assignmentDetail?.type?.key === 'submission'">
																	<ng-container
																		*ngIf="assignmentDetail?.status?.key === 'submitted' && assignmentDetail?.completedTime">
																		<app-common-view class="common-view-info"
																			[data]="{label: locale.translate('submitted'), value: assignmentDetail?.completedTime}">
																		</app-common-view>
																	</ng-container>
																	<ng-container
																		*ngIf="assignmentDetail?.status?.key === 'closed' && assignmentDetail?.evalDT">
																		<app-common-view class="common-view-info"
																			[data]="{label: locale.translate('completed'), value: assignmentDetail?.evalDT}">
																		</app-common-view>
																	</ng-container>
																</ng-container>

											
																<div class="sub-txt-patch asg-status" [ngClass]="assignmentDetail?.status.key">
																	{{assignmentDetail?.status?.caption}}
																</div>
															</div>
														</div>
														<div class="progress-dtls" fxLayout="row" fxLayoutAlign="center center">
															<mat-progress-bar class="progress-br" color="primary" mode="determinate"
																[value]="assignmentDetail?.progress">
															</mat-progress-bar>
														</div>
													</div>
													<ng-container
														*ngIf="!['assigned', 'overdue'].includes(assignmentDetail?.status?.key) && assignmentDetail?.status?.key !== 'closed' && assignmentDetail?.status?.key === 'submitted'">
														<div class="button-blocks"  fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.xs="center center"
															fxLayoutGap="5px">
															<button class="submit-btn" mat-stroked-button #workGroupAssignmentEvaluateBtn
																(click)="submit('evaluate', workGroupAssignmentEvaluateBtn, assignmentDetail)">
																{{locale.translate('evaluate')}}
															</button>
															<button mat-button class="reassign-btn" type="button" #workGroupAssignmentReassignBtn
																(click)="submit('reassign', workGroupAssignmentReassignBtn, assignmentDetail)">
																<div fxLayoutAlign="center center" fxLayoutGap="5px">
																	<mat-icon class="reply-icon">replay</mat-icon>
																	<span>{{locale.translate('reassign')}}</span>
																</div>
															</button>
														</div>
													</ng-container>
												</div>
											</ng-container>
										</div>
										</div>
									</div>
								</ng-container>
								
								<!---end-->
							</div>
						</div>

						<ng-container
							*ngIf="!['assigned', 'overdue'].includes(assignmentDetail?.status?.key) && (assignmentDetail?.completedTime || assignmentDetail?.assigneeNotes)">
							<div class="detail-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="24px">
								<h4 class="detail-block-title">
									{{locale.translate('submission')}} / {{locale.translate('completion')}}
								</h4>
								<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
									<div class="detail-block-body" fxLayout="row wrap" fxLayoutAlign="space-between stretch"
										fxLayoutGap="10px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="10px">
										<div fxLayout="row wrap" fxLayoutAlign="start center" class="data-container">
											<div class="data-item" fxFlex="220px" fxFlex.xs="auto">
												<app-common-view
													[data]="{label: locale.translate('submitted_on'), value: assignmentDetail?.completedTime}">
												</app-common-view>
											</div>
										</div>
										<ng-container
											*ngIf="assignmentDetail?.status?.key !== 'closed' && assignmentDetail?.status?.key === 'submitted' && currentUser?.userID === assignmentDetail?.assigner?.userID">
											<div class="button-blocks" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="32px">
												<button class="submit-btn" mat-stroked-button #evaluateBtn
													(click)="submit('evaluate', evaluateBtn, assignmentDetail)">{{locale.translate('evaluate')}}</button>
												<button mat-button class="reassign-btn" type="button" #reassignBtn
													(click)="submit('reassign', reassignBtn, assignmentDetail)">
													<div fxLayoutAlign="center center" fxLayoutGap="5px">
														<mat-icon class="reply-icon">replay</mat-icon>
														<span>{{locale.translate('reassign')}}</span>
													</div>
												</button>
											</div>
										</ng-container>
									</div>

									<ng-container *ngIf="assignmentDetail?.assigneeNotes">
										<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
											<app-common-view
												[data]="{label: locale.translate('notes'), value: assignmentDetail?.assigneeNotes}">
											</app-common-view>
										</div>
									</ng-container>
								</div>
							</div>
						</ng-container>

						<ng-container *ngIf="assignmentDetail?.status?.key === 'closed' && assignmentDetail?.score?.score">
							<div class="detail-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
								<h4 class="detail-block-title">
									{{locale.translate('evaluation')}}
								</h4>
								<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px">
									<div class="detail-block-body" fxLayout="row wrap" fxLayoutAlign="space-between stretch"
										fxLayoutGap="10px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="10px">
										<div fxLayout="row wrap" fxLayoutAlign="start center" class="data-container">
											<div class="data-item" fxFlex="220px" fxFlex.xs="auto">
												<app-common-view
													[data]="{label: locale.translate('score'), value: assignmentDetail?.score?.score}">
												</app-common-view>
											</div>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
					<ng-container *ngIf="assignmentDetail?.reassignReference || history?.length">
						<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.xs="column"
							fxLayoutGap.xs="5px" class="assignment-detail-footer">
							<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
								<mat-icon class="reply">replay</mat-icon>
								<p class="label">{{locale.translate('has_been_reassigned')}}</p>
							</div>
							<div *ngIf="history?.length === 0">
								<button mat-button class="view-history" (click)="viewHistory()">
									{{locale.translate('view_history')}}
								</button>
							</div>
							<ng-container *ngIf="history?.length">
								<div fxLayout="row" fxLayoutAlign="center center">
									<button mat-icon-button (click)="prev()" class="arrow" [disabled]="historyIndex === 0">
										<mat-icon>keyboard_arrow_left</mat-icon>
									</button>
									<p class="label">{{locale.translate('history')}} ({{(historyIndex + 1)}}/{{history?.length}})</p>
									<button mat-icon-button (click)="next()" class="arrow"
										[disabled]="history?.length === (historyIndex + 1)">
										<mat-icon>keyboard_arrow_right</mat-icon>
									</button>
								</div>
							</ng-container>
						</div>
					</ng-container>
				</div>
			</ng-container>
		</content-area>
	</app-content-view>
</ng-container>

<ng-container *ngIf="viewType === 'info' && assignmentDetail">
	<div class="assign-view-info" fxLayout="row" fxLayoutAlign="start stretch" fxLayout.xs="column"
		fxLayoutAlign.xs="start stretch" fxLayoutGap="20px" fxLayoutGap.xs="10px">
		<div class="assigning-process" fxFlex="1 1" fxLayout="row wrap" fxLayoutAlign="start stretch" fxLayoutGap="20px"
			fxLayoutGap.xs="10px">
			<!-- <div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="10px"> -->
			<div fxLayout="row" fxLayoutAlign="start center">
				<mat-icon class="asgment-icon" svgIcon="assignment"></mat-icon>
			</div>
			<!-- </div> -->
			<div class="asg-view cursor-pointer" fxFlex="0 1 280px" matRipple fxLayout="row"
				fxLayoutAlign="space-between center" fxLayoutGap="10px" (click)="assignmentInfo()">
				<ng-container *ngIf="currentUser?.userID !== assignmentDetail?.assigner?.userID">
					<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
						<ng-container *ngIf="assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName">
							<mat-icon svgIcon="workgroup"></mat-icon>
						</ng-container>
						<ng-container *ngIf="!(assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName)">
							<img [src]="assignmentDetail?.assigner?.profilePicURL" (error)="gfService.setErrorImage($event, 'man')"
								class="thumbnail">
						</ng-container>
						<ng-container *ngIf="assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName">
							<div class="assigning-info">
								{{assignmentDetail?.workgroup?.groupName}}
							</div>
						</ng-container>
						<ng-container *ngIf="!(assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName) &&
							![null,undefined].includes(assignmentDetail?.assigners)">
							<div class="assigning-info"
								[innerHtml]="locale.translate('assigned_to_you') | handleBar : {'name': assignmentDetail?.assigners}">
							</div>
						</ng-container>
					</div>
				</ng-container>

				<ng-container *ngIf="currentUser?.userID === assignmentDetail?.assigner?.userID">
					<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
						<ng-container *ngIf="assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName">
							<mat-icon svgIcon="workgroup"></mat-icon>
						</ng-container>
						<ng-container *ngIf="!(assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName)">
							<img [src]="assignmentDetail?.assignee?.profilePicURL" (error)="gfService.setErrorImage($event, 'man')"
								class="thumbnail">
						</ng-container>
						<ng-container *ngIf="assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName">
							<div class="assigning-info"
								[innerHtml]="locale.translate('assign_by_me_desc') | handleBar : {'name': assignmentDetail?.workgroup?.groupName}">
								<!-- {{locale.translate('assign_by_prefix')}} <b>{{assignmentDetail?.assignee?.name}}</b> {{locale.translate('assign_by_suffix')}} -->
							</div>
						</ng-container>
						<ng-container *ngIf="!(assignmentDetail?.workgroup && assignmentDetail?.workgroup?.groupName) &&
							![null,undefined].includes(assignmentDetail?.assignee?.name)">
							<div class="assigning-info"
								[innerHtml]="locale.translate('assign_by_me_desc') | handleBar : {'name': assignmentDetail?.assignee?.name}">
								<!-- {{locale.translate('assign_by_prefix')}} <b>{{assignmentDetail?.assignee?.name}}</b> {{locale.translate('assign_by_suffix')}} -->
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>

			<div fxLayout="row" fxLayoutAlign="center center">
				<div class="sub-txt-patch" [ngClass]="{'success' : (['submitted','assigned'].includes(assignmentDetail?.status?.key)),
				'error' : (['reassigned','closed', 'overdue', 'aborted'].includes(assignmentDetail?.status?.key))}">
					{{assignmentDetail?.status?.caption}}
				</div>
			</div>
			<div fxflex="1 0" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" fxLayoutGap.xs="10px">
				<ng-container *ngIf="assignmentDetail?.assigneeNotes">
					<div>
						<!-- <app-readability [height]="30" [canRead]="false">
							<content> -->
						<p fxFlex="1 0" class="instruction" [innerHtml]="assignmentDetail?.assigneeNotes | nl2br"></p>
						<!-- </content>
						</app-readability> -->
					</div>
				</ng-container>
				<ng-container *ngIf="!assignmentDetail?.assigneeNotes && assignmentDetail?.assignerNotes">
					<div>
						<!-- <app-readability [height]="30" [canRead]="false">
							<content> -->
						<p fxFlex="1 0" class="instruction" [innerHtml]="assignmentDetail?.assignerNotes | nl2br"></p>
						<!-- </content>
						</app-readability> -->
					</div>
				</ng-container>
				<div class="status-info">
					<ng-container *ngIf="assignmentDetail?.completedTime">
						<app-common-view [data]="{label: locale.translate('submitted_on'), value: assignmentDetail?.completedTime}">
						</app-common-view>
					</ng-container>
					<ng-container *ngIf="!assignmentDetail?.completedTime && assignmentDetail?.completeByTime">
						<app-common-view
							[data]="{label: (assignmentDetail?.type?.key === 'submission') ? locale.translate('submit_by') : locale.translate('complete_by'), value: assignmentDetail?.completeByTime}">
						</app-common-view>
					</ng-container>
				</div>
			</div>
			<div class="btn-containter" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
				<ng-container
					*ngIf="(currentUser?.userID === assignmentDetail?.assigner?.userID) && assignmentDetail?.status?.key === 'submitted'">
					<div>
						<button class="submit-btn" mat-stroked-button (click)="submit('evaluate', evaluateBtn, assignmentDetail)"
							#evaluateBtn>
							{{locale.translate('evaluate')}}</button>
					</div>
					<div>
						<button mat-button color="accent" class="reassign-btn" type="button"
							(click)="submit('reassign', reassignBtn, assignmentDetail)" #reassignBtn>
							<div fxLayoutAlign="center center" fxLayoutGap="5px">
								<mat-icon class="reply-icon">replay</mat-icon>
								<span>{{locale.translate('reassign')}}</span>
							</div>
						</button>
					</div>
				</ng-container>
				<ng-container
					*ngIf="(currentUser?.userID === assignmentDetail?.assignee?.userID) && ['assigned', 'overdue'].includes(assignmentDetail?.status?.key) && assignmentDetail?.type?.key === 'submission'">
					<div>
						<button class="submit-btn" mat-stroked-button (click)="submit('submit', submitBtn, assignmentDetail)"
							#submitBtn>
							{{locale.translate('submit')}}</button>
					</div>
				</ng-container>
				<ng-container
					*ngIf="(currentUser?.userID === assignmentDetail?.assignee?.userID) && ['assigned', 'overdue'].includes(assignmentDetail?.status?.key) && assignmentDetail?.type?.key !== 'submission'">
					<div>
						<button #markAsReadBtn [disabled]="buttonDisable || !resourceData?.read" class="secondary-btn"
							mat-stroked-button (click)="submit('markAsRead', markAsReadBtn, assignmentDetail)">
							{{locale.translate('mark_as_complete')}}</button>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</ng-container>
